import * as BABYLON from "babylonjs";

export class GeoPoint {
    static readonly EarthRadius = 6378137.0;

    constructor(readonly latitude = 0.0, readonly longitude = 0.0, readonly altitude = 0.0) {
    }

    get latitudeAsRadians() { return (Math.PI / 180.0) * this.latitude; }

    get longitudeAsRadians() { return (Math.PI / 180.0) * this.longitude; }

    toString(): string {
        return `[lat: ${this.latitude}, lon: ${this.longitude}, alt: ${this.altitude}]`;
    }

    toEcefCoords(): BABYLON.Vector3 {
        let cosLat = Math.cos(this.latitudeAsRadians);
        let sinLat = Math.sin(this.latitudeAsRadians);
        let cosLon = Math.cos(this.longitudeAsRadians);
        let sinLon = Math.sin(this.longitudeAsRadians);
        let radius = GeoPoint.EarthRadius + this.altitude;

        let x = radius * cosLat * cosLon;
        let y = radius * cosLat * sinLon;
        let z = radius * sinLat;

        return new BABYLON.Vector3(x, y, z);
    }

    toEnuCoords(origin: GeoPoint): BABYLON.Vector3 {
        let ecefPosition = this.toEcefCoords();
        let ecefOrigin = origin.toEcefCoords();
        let ecefDelta = ecefPosition.subtract(ecefOrigin);

        let cosOrigLat = Math.cos(origin.latitudeAsRadians);
        let sinOrigLat = Math.sin(origin.latitudeAsRadians);
        let cosOrigLon = Math.cos(origin.longitudeAsRadians);
        let sinOrigLon = Math.sin(origin.longitudeAsRadians);

        let x = -sinOrigLon * ecefDelta.x + cosOrigLon * ecefDelta.y;
        let y = -sinOrigLat * cosOrigLon * ecefDelta.x - sinOrigLat * sinOrigLon * ecefDelta.y + cosOrigLat * ecefDelta.z;
        let z = cosOrigLat * cosOrigLon * ecefDelta.x + cosOrigLat * sinOrigLon * ecefDelta.y + sinOrigLat * ecefDelta.z;

        return new BABYLON.Vector3(x, y, z);
    }

    static fromEcefCoords(ecef: BABYLON.Vector3): GeoPoint {
        let radius = ecef.length();
        let alt = radius - GeoPoint.EarthRadius;
        let lat = Math.asin(ecef.z / radius);
        let lon = Math.atan2(ecef.y, ecef.x);
        lat *= (180.0 / Math.PI);
        lon *= (180.0 / Math.PI);
        return new GeoPoint(lat, lon, alt);
    }

    static fromEnuCoords(enu: BABYLON.Vector3, origin: GeoPoint): GeoPoint {
        let ecefOrigin = origin.toEcefCoords();

        let cosOrigLat = Math.cos(origin.latitudeAsRadians);
        let sinOrigLat = Math.sin(origin.latitudeAsRadians);
        let cosOrigLon = Math.cos(origin.longitudeAsRadians);
        let sinOrigLon = Math.sin(origin.longitudeAsRadians);

        let x = -sinOrigLon * enu.x - sinOrigLat * cosOrigLon * enu.y + cosOrigLat * cosOrigLon * enu.z + ecefOrigin.x;
        let y = cosOrigLon * enu.x - sinOrigLat * sinOrigLon * enu.y + cosOrigLat * sinOrigLon * enu.z + ecefOrigin.y;
        let z = cosOrigLat * enu.y + sinOrigLat * enu.z + ecefOrigin.z;

        let ecef = new BABYLON.Vector3(x, y, z);
        return GeoPoint.fromEcefCoords(ecef);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/geoPoint.ts